/* Step tiles — numbered step headers and "Choose" button */

export const stepTilesParts = [
  'stepTile',
  'stepTileDisabled',
  'stepTileNumber',
  'stepTileTitle',
  'stepTileSelection',
  'stepChooseButton',
  'stepHeading',
  'stepSection',
  'stepDivider',
  'stepDescription',
  'pickerContainerDescription',
  'optionStepRadioContainer',
  'optionStepListRadio',
  'optionStepListSwatch',
  'optionStepListLocked',
  'optionStepLoadingMore',
  'optionStepLoadingMoreSpinner',
  'optionStepLoadingMoreText',
  'stepDescriptionBody'
];

export const stepTilesBaseStyle = {
  stepTile: {
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'gray.200',
    borderRadius: 'md',
    display: 'flex',
    padding: 4,
    marginBottom: 3,
  },
  stepTileDisabled: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
  stepTileNumber: {
    color: 'gray.600',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  stepTileTitle: {
    fontSize: 'sm',
    fontWeight: 'semibold',
  },
  stepTileSelection: {
    color: 'gray.600',
    fontSize: 'xs',
    marginTop: 1,
  },
  stepChooseButton: {
    flexShrink: 0,
  },
  stepHeading: {
    color: 'brandColors.greyscale',
    fontFamily: 'body',
    fontSize: {base: '16px', lg: '18px'},
    fontStyle: 'normal',
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 500,
    lineHeight: {base: 1.4, lg: 1.2},
    marginBottom: {base: '20px', lg: '24px'},
  },
  stepSection: {
    marginBottom: {base: '24px', lg: '38px'},
    sx: {
      '.configuration-selector-panel__desktop-container & ': {
        marginBottom: {base: '56px', lg: '64px'},
      },
      '&.customize-steps-main-view-step--cover': {
        marginTop: {base: '11px', md: 'unset'},
      },
      '&[aria-disabled="true"]': {
        '& > .chakra-text': {
          color: 'greyscale.70',
          fontWeight: 500,
        },
        '& .customize-steps-step-information .amb-markup .content > :is(p, h1, h2, h3, h4, h5, h6)': {
          color: 'greyscale.70',
        },
        '& .customize-steps-step-information .amb-markup .content > :is(p, h1, h2, h3, h4, h5, h6) :is(strong, b)': {
          color: 'greyscale.70',
        },
        '& .customize-steps-step-information .amb-markup .content a': {
          color: 'greyscale.70',
          _hover: {color: 'greyscale.70'},
        },
        '& .slot-card-content-text-empty-slot-label, & .slot-card-content-text-empty-title, & .slot-card-content-text-empty-hint': {
          color: 'greyscale.70',
        },
        '& .slot-card-choose-button': {
          color: 'greyscale.70',
          _hover: {color: 'greyscale.70', opacity: 1},
        },
      },
    },
  },
  stepDivider: {
    borderTop: '1px solid',
    borderColor: 'gray.200',
    marginBottom: {base: '56px', lg: '64px'},
  },
  stepDescription: {
    alignSelf: 'stretch',
    backgroundColor: 'brandColors.primaryBG',
    borderRadius: '6px',
    display: 'block',
    marginBottom: '8px',
    p: '24px',
  },
  pickerContainerDescription: {
    color: 'brandColors.greyscale',
    fontFamily: 'body',
    fontSize: 'md',
    fontStyle: 'normal',
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 'semibold',
    lineHeight: 'base',
    marginBottom: '24px',
    wordBreak: 'break-word',
  },
  optionStepRadioContainer: {
    overflow: 'hidden',
    sx: {
      '&.customize-steps-option-step--cushion': {
        '& .radio-option-content-description': {
          color: '#7C7C7C',
          fontSize: {base: '13px', lg: '12px'},
        },
      },
    },
  },
  optionStepListRadio: {
    sx: {
      '& .option-inner-radio-item': {
        padding: 4,
        gap: 4,
      },
    },
  },
  optionStepListSwatch: {
    columns: {base: 4, lg: 4},
    gap: {base: '4px', lg: '6px'},
    w: 'full',
  },
  optionStepListLocked: {
    opacity: 0.55,
    pointerEvents: 'none',
  },
  optionStepLoadingMore: {
    alignItems: 'center',
    flexDirection: 'column',
    gap: 3,
    justifyContent: 'center',
    minHeight: {base: '72px', lg: '80px'},
    paddingY: 4,
  },
  optionStepLoadingMoreSpinner: {
    color: 'gray.600',
    size: 'md',
    thickness: '3px',
  },
  optionStepLoadingMoreText: {
    color: 'gray.600',
    fontSize: 'sm',
  },
  stepDescriptionBody: {
    fontFamily: 'body',
    minWidth: 0,
    width: '100%',
    sx: {
      '& .amb-markup': {
        alignItems: 'start',
        columnGap: '16px',
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        minWidth: 0,
        width: '100%',
      },
      '& .amb-markup > .content': {
        gridColumn: 1,
        minWidth: 0,
      },
      '& .amb-markup > *:not(.content)': {
        alignSelf: 'center',
        gridColumn: 2,
        gridRow: '1 / -1',
        justifySelf: 'end',
      },
      '& .amb-markup .content': {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minWidth: 0,
        width: '100%',
      },
      '& .amb-markup .content :is(h1, h2, h3, h4, h5, h6, p)': {
        margin: 0,
        marginBottom: 0,
        marginTop: 0,
      },
      '& .amb-markup .content > h1:first-child, & .amb-markup .content > h2:first-child, & .amb-markup .content > h3:first-child, & .amb-markup .content > h4:first-child, & .amb-markup .content > h5:first-child, & .amb-markup .content > h6:first-child': {
        color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
        fontFamily: 'body',
        fontSize: '14px',
        fontStyle: 'normal',
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      '& .amb-markup .content > p:first-child': {
        color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
        fontFamily: 'body',
        fontSize: '14px',
        fontStyle: 'normal',
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontWeight: 600,
        lineHeight: 1.4,
        '&  strong, &  b': {
          fontWeight: 600,
          color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
        },
      },
      '& .amb-markup .content > p:not(:first-child)': {
        color: 'greyscale.70',
        fontFamily: 'body',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 1.2,
      },
      '& .amb-markup .content a': {
        color: 'primary.darkLinen',
        fontFamily: 'body',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 1.2,
        textDecoration: 'underline',
        textDecorationSkipInk: 'none',
        textUnderlineOffset: '35%',
        textUnderlinePosition: 'from-font',
        _hover: {color: 'primary.darkLinen'},
      },
      '.customize-steps-main-view-step[aria-disabled="true"] & .amb-markup .content > :is(p, h1, h2, h3, h4, h5, h6):first-child': {
        'color': 'greyscale.70',
        '& strong, & b': {
          color: 'greyscale.70',
        },
      },
      '.customize-steps-main-view-step[aria-disabled="true"] & .amb-markup .content > p:not(:first-child)': {
        color: 'greyscale.70',
      },
      '.customize-steps-main-view-step[aria-disabled="true"] & .amb-markup .content a': {
        color: 'greyscale.70',
        _hover: {color: 'greyscale.70'},
      },
    },
  },
};
